// src/utils/assessmentUtils.js

// Scoring and mapping logic for assessment answers
export function mapAnswersToProblems(answers) {
  const problems = [];

  // Stress (PSS-4): moderate/high if score > 4
  const stressScore = answers.stress_1 + (4 - answers.stress_2) + (4 - answers.stress_3) + answers.stress_4;
  if (stressScore > 4) problems.push("stress");

  // Vitamin D: flag if 2+ risk factors (yes = 1)
  const vitdRisk = [answers.vitd_1, answers.vitd_2, answers.vitd_3, answers.vitd_4, answers.vitd_5].filter(a => a === 1).length;
  if (vitdRisk >= 2) problems.push("vitd");

  // Anxiety (GAD-2): clinical if score >= 3
  const anxietyScore = answers.anxiety_1 + answers.anxiety_2;
  if (anxietyScore >= 3) problems.push("anxiety");

  // Add more mappings as needed (e.g., for loneliness, burnout, etc.)

  return problems;
}
